import { createSlice } from "@reduxjs/toolkit";

export interface EBMTrainingStatusState {
  payload: boolean;
}

const slice = createSlice({
  name: "ebmTrainingStatus",
  initialState: { payload: false } as EBMTrainingStatusState,
  reducers: {
    ebmTrainingStatus: (
      state,
      { payload }: { payload: EBMTrainingStatusState }
    ) => {
      state.payload = payload.payload;
    }
  }
});

export const { ebmTrainingStatus } = slice.actions;
export default slice.reducer;
